/*
 * @Author: zhangsheng
 * @Date: 2023-08-22 14:53:39
 * @LastEditors: zhangsheng
 * @LastEditTime: 2025-12-22 11:45:02
 * @FilePath: \panda-index-sicermem-frontend - 副本\src\pc\router\pageRouter.tsx
 * @Description:
 *
 * Copyright (c) 2023 by zhangsheng , All Rights Reserved.
 */
// import { MenuRoute } from '@c/types/router';
import { lazy } from 'react';
import lazyLoad from '@c/components/lozyLoad';
import React from 'react';
import { Navigate } from 'react-router';
import i18next from '@/i18n';
const About = lazyLoad(lazy(() => import(`@p/pages/About`)));
const Contact = lazyLoad(lazy(() => import(`@p/pages/Contact`)));
const Features = lazyLoad(lazy(() => import(`@p/pages/Features`)));
const Team = lazyLoad(lazy(() => import(`@p/pages/Team`)));
const Testimonials = lazyLoad(lazy(() => import(`@p/pages/Testimonials`)));
const Pricing = lazyLoad(lazy(() => import(`@p/pages/Pricing`)));

const pageRouter: any = [
  {
    path: '',
    name: '首页',
    key: '/about',
    // index: true,
    hideMenu: true,
    exact: true,
    element: About,
  },
  {
    path: 'features',
    name: 'features',
    key: '/Features',
    element: Features,
  },
  {
    path: 'team',
    name: 'team',
    key: '/Team',
    element: Team,
  },
  {
    path: 'testimonials',
    name: 'testimonials',
    key: '/Testimonials',
    element: Testimonials,
  },
  {
    path: 'pricing',
    name: 'pricing',
    key: '/Pricing',
    element: Pricing,
  },
  {
    path: 'contact',
    name: 'contact',
    key: '/Contact',
    element: Contact,
  },
  {
    path: '*',
    name: '404',
    key: '/404',
    hideMenu: true,
    element: <Navigate to="/404" replace />,
  },
];

export default pageRouter;
